import { parseDateOnlyString } from "@gettactic/api";
import { format } from "date-fns";

/**
 * "9/07/26", "9/07/26 until 9/09/26" or "Always" for an hour rule's date
 * window. Inputs are ISO date strings such as "2026-09-07T00:00:00Z".
 */
export function getDateWindowMessage(
  hourSince: string | null,
  hourUntil: string | null
): string {
  const since = hourSince ? parseDateOnlyString(hourSince) : null;
  const until = hourUntil ? parseDateOnlyString(hourUntil) : null;
  const sinceFormatted = since ? format(since, "M/dd/yy") : "";
  const untilFormatted = until ? format(until, "M/dd/yy") : "";
  if (!since && !until) {
    return "Always";
  }
  if (sinceFormatted === untilFormatted) {
    return sinceFormatted;
  }
  if (since && !until) {
    return sinceFormatted;
  }
  if (until && !since) {
    return untilFormatted;
  }
  return `${sinceFormatted} until ${untilFormatted}`;
}
